import React from "react";

type DividerProps = {
    id?: string;
}

const Divider = ({id}: DividerProps) => {
    return (
        <div id={id} data-testid={id} className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#DFE0E6]`}/>
    );
}
export default Divider;